export const microsoftDashboardBreakPoint = 550;
